import { render, staticRenderFns } from "./consultantDetails.vue?vue&type=template&id=023f8150&scoped=true"
import script from "./consultantDetails.vue?vue&type=script&lang=js"
export * from "./consultantDetails.vue?vue&type=script&lang=js"
import style0 from "./consultantDetails.vue?vue&type=style&index=0&id=023f8150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f8150",
  null
  
)

export default component.exports